import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { clearSession } from '../../utils/AuthSession'

function Logout() {
  const navigate = useNavigate()
  useEffect(() => {
    clearSession()
    navigate('/auth/login', { replace: true })
  }, [navigate])
  return <div>Keluar...</div>
}

export default Logout
